const home = {
  hero: {
    badge: "Niezależne centrum zasobów",
    title: "Arkusz USFans: Znajdź, Porównaj i Przeglądaj Zasoby",
    subtitle: "Poznaj arkusz USFans, kategorie produktów, informacje o sprzedawcach, poradniki dotyczące wysyłki, recenzje, kupony, szczegóły magazynu i praktyczne narzędzia badawcze — wszystko w jednym, łatwym w obsłudze centrum zasobów.",
    searchPlaceholder: "Szukaj produktów, sprzedawców, wysyłki lub poradników...",
    trust: "Niezależne zasoby · Aktualne poradniki · Wielojęzyczne · Skupione na bezpieczeństwie",
    primaryCta: "Przeglądaj arkusz USFans",
    secondaryCta: "Odwiedź główną stronę",
    supportTitle: "Szukasz arkusza USFans?",
    supportText: "Znajdź uporządkowane zasoby, poradniki badawcze, porównania i praktyczne informacje, które pomogą Ci zrozumieć USFans przed podjęciem decyzji.",
    explore: [
      "Zasoby arkusza",
      "Badanie produktów",
      "Informacje o sprzedawcach",
      "Koszty wysyłki",
      "Poradniki magazynowe",
      "Recenzje",
      "Kupony i rabaty",
      "Wskazówki bezpieczeństwa",
    ],
  },
  cta: {
    exploreSpreadsheet: "Przeglądaj arkusz",
    usfansSpreadsheet: "Arkusz USFans",
    buyItNow: "Kup teraz",
    visitMain: "Odwiedź główną stronę",
    exploreAll: "Przeglądaj wszystkie zasoby",
    continueMain: "Przejdź do głównej strony",
  },
  categories: {
    title: "Przeglądaj kategorie produktów",
    subtitle: "Wybierz kategorię poniżej, aby zobaczyć najnowsze produkty dostępne na głównej stronie.",
    dropdownLabel: "Wybierz kategorię",
    dropdownPlaceholder: "Wybierz kategorię produktów...",
    items: {
      shoes: "Buty",
      hoodies: "Bluzy / Swetry",
      tshirts: "Koszulki",
      jackets: "Kurtki",
      pants: "Spodnie / Szorty",
      headwear: "Nakrycia głowy",
      sets: "Zestawy",
      underwear: "Bielizna",
      jersey: "Koszulka sportowa",
      accessories: "Akcesoria",
      bags: "Torby",
      belts: "Paski",
      perfumes: "Perfumy",
      other: "Inne rzeczy",
    },
  },
  resources: {
    title: "Popularne zasoby",
    subtitle: "Wszystko, czego potrzebujesz, aby zbadać USFans, uporządkowane w proste tematy.",
    items: [
      { title: "Arkusz USFans", desc: "Poznaj zasoby, listy i poradniki badawcze arkusza." },
      { title: "Recenzja USFans", desc: "Zrozum funkcje, zalety, ograniczenia i uwagi." },
      { title: "Koszt wysyłki USFans", desc: "Dowiedz się, co wpływa na koszty wysyłki i jak porównać opcje." },
      { title: "Magazyn USFans", desc: "Zrozum magazynowanie, przetwarzanie i powiązane uwagi." },
      { title: "Kupon i kod rabatowy", desc: "Znajdź aktualne informacje o kuponach i rabatach, gdy są dostępne." },
      { title: "Czy USFans jest legalne?", desc: "Przeczytaj nasz niezależny poradnik o bezpieczeństwie i legalności." },
    ],
  },
  hub: {
    title: "Twoje centrum zasobów arkusza USFans",
    copy: "USFansSheet.live porządkuje zasoby arkusza USFans w przeszukiwalne kategorie, dzięki czemu spędzasz mniej czasu na szukaniu, a więcej na badaniu.",
    cards: ["Listy arkusza", "Badanie produktów", "Badanie sprzedawców", "Wysyłka", "Magazyn", "Recenzje", "Kupony", "Bezpieczeństwo"],
  },
  why: {
    title: "Wszystko, czego potrzebujesz, aby zbadać USFans w jednym miejscu",
    items: [
      { title: "Uporządkowane", desc: "Znajdź powiązane informacje o arkuszu USFans bez przeskakiwania między niepowiązanymi stronami." },
      { title: "Praktyczne", desc: "Poradniki koncentrują się na realnych pytaniach, których ludzie naprawdę szukają." },
      { title: "Aktualne", desc: "Ważne informacje zawierają daty publikacji i aktualizacji." },
      { title: "Przejrzyste", desc: "Wyraźnie rozróżniaj zweryfikowane fakty, analizę redakcyjną i informacje, które mogą się zmieniać." },
      { title: "Wielojęzyczne", desc: "Dostępne po angielsku, polsku, hiszpańsku i francusku." },
    ],
  },
  comparison: {
    title: "Porównanie zasobów USFans",
    subtitle: "Szybki przegląd tego, czego pomaga nauczyć się dany zasób i dla kogo jest najlepszy.",
    headers: ["Temat", "Czego się dowiesz", "Dla kogo"],
    rows: [
      ["Arkusz", "Listy, produkty i badania", "Badanie produktów"],
      ["Recenzja", "Funkcje i ograniczenia", "Początkujący"],
      ["Koszt wysyłki", "Czynniki kosztów i opcje", "Badanie wysyłki"],
      ["Magazyn", "Magazynowanie i przetwarzanie", "Obecni użytkownicy"],
      ["Kupon", "Dostępne promocje", "Oszczędzanie pieniędzy"],
      ["Poradnik legalności", "Bezpieczeństwo i weryfikacja", "Świadomość ryzyka"],
    ],
  },
  guides: {
    title: "Najnowsze poradniki",
    subtitle: "Przeczytaj nasze oryginalne, niezależnie napisane poradniki i artykuły.",
    readGuide: "Przeczytaj poradnik",
    readArticle: "Przeczytaj artykuł",
    comingSoon: "Wkrótce",
    updatedLabel: "Zaktualizowano",
  },
  articleSection: {
    title: "Artykuły o arkuszu USFans",
    subtitle: "Oryginalne, pogłębione poradniki, które pomogą Ci zbadać i zrozumieć USFans.",
    cardTitle: "Czym jest arkusz USFans?",
    cardDesc: "Kompletny, przyjazny dla początkujących poradnik o tym, jak działa arkusz USFans, jak go przeszukiwać i jak zachować bezpieczeństwo.",
    readMore: "Przeczytaj cały poradnik",
  },
  safety: {
    title: "Zbadaj, zanim kupisz",
    copy: "Zasoby online mogą się zmieniać. Linki, sprzedawcy, ceny, warunki wysyłki i promocje nie zawsze są aktualne. Zawsze weryfikuj ważne informacje przed dokonaniem płatności lub udostępnieniem danych osobowych.",
    cta: "Przeczytaj poradnik bezpieczeństwa USFans",
  },
  mainCta: {
    title: "Gotowy, aby poznać więcej?",
    copy: "Wykorzystaj nasze poradniki i zasoby arkusza USFans jako punkt wyjścia, a następnie przejdź do głównej strony po najnowsze dostępne informacje.",
  },
  faq: {
    title: "Często zadawane pytania",
    items: [
      { q: "Czym jest arkusz USFans?", a: "Arkusz USFans to uporządkowane, przeszukiwalne źródło, które zestawia i porównuje produkty, kategorie, sprzedawców oraz powiązane informacje badawcze. Pomaga kupującym szybciej znaleźć to, czego szukają." },
      { q: "Jak działa arkusz USFans?", a: "Grupuje produkty i informacje w kategorie, dzięki czemu możesz przeglądać, szukać i porównywać opcje w jednym miejscu zamiast odwiedzać wiele oddzielnych stron." },
      { q: "Czy USFans jest legalne?", a: "Zapewniamy niezależne wskazówki pomagające zweryfikować informacje, ale nie możemy zagwarantować legalności żadnego sprzedawcy. Zawsze dokładnie badaj i sprawdzaj aktualne informacje przed zakupem." },
      { q: "Ile kosztuje wysyłka USFans?", a: "Koszty wysyłki mogą się zmieniać w zależności od lokalizacji, metody i sprzedawcy. Wyjaśniamy czynniki wpływające na wysyłkę, abyś mógł samodzielnie porównać opcje." },
      { q: "Czy USFans oferuje kupony?", a: "Promocje i kupony mogą być dostępne w określonych momentach. Opisujemy, jak szukać aktualnych okazji, ale nie publikujemy gwarantowanych ani niezweryfikowanych kodów rabatowych." },
      { q: "Gdzie znajdę kody rabatowe USFans?", a: "Zawsze szukaj kodów na oficjalnej głównej stronie lub w zweryfikowanych kanałach. Uważaj na nieoficjalne kody, które mogą być nieaktualne lub mylące." },
      { q: "Czym jest magazyn USFans?", a: "Magazyn odnosi się do sposobu przechowywania i przetwarzania produktów przed wysyłką. Wyjaśniamy ogólną koncepcję i rzeczy, które warto wziąć pod uwagę." },
      { q: "Czy arkusz USFans jest oficjalny?", a: "USFansSheet.live to niezależne źródło informacji i nie jest koniecznie powiązane z USFans ani przez nie popierane." },
      { q: "Jak zweryfikować informacje?", a: "Porównaj szczegóły na głównej stronie, sprawdź najnowsze aktualizacje i potwierdź ceny, wysyłkę oraz dostępność przed dokonaniem płatności lub udostępnieniem danych osobowych." },
      { q: "Jak często aktualizowane są zasoby?", a: "Staramy się, aby informacje były aktualne, ale szczegóły mogą się szybko zmieniać. Zawsze sprawdzaj główną stronę po najnowsze informacje." },
    ],
  },
};

export default home;